import request from './base'

export default {
  /**
   * 登录
   * params: {
   *  dto: {
   *    partnerId: '10000',
   *    loginName: 'xiaowenwen',
   *    pwd: '123456'
   *  }
   * }
   */
  userLogin: (commit, payload, mutation) => {
    let options = request.getOptions('/customer/login', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 退出登录
   */
  loginOut: (commit, payload, mutation) => {
    let options = request.getOptions('/customer/loginOut', payload)
    return request.get(commit, options, mutation)
  },
  /**
   * 添加认证
   */
  applyAddorupdate: (commit, payload, mutation) => {
    let options = request.getOptions('/apply/addorupdate', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 获取公司名称
   */
  queryPartnerListToShowByName: (commit, payload, mutation) => {
    let options = request.getOptions('/partner/queryPartnerListToShowByName', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 获取个人信息
   */
  applyCustomer: (commit, payload, mutation) => {
    let options = request.getOptions('/apply/customer', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 加密登录
   * params: {
   *  dto: {
   *    partnerId: '10000',
   *    loginName: 'xiaowenwen',
   *    pwd: '123456'
   *  }
   * }
   */
  loginEncryptionPortal: (commit, payload, mutation) => {
    let options = request.getOptions('/customer/loginEncryptionPortal', payload)
    return request.post(commit, options, mutation)
  },
  updatePwd: (commit, payload, mutation) => {
    let options = request.getOptions('/customer/updatePwd', payload)
    return request.post(commit, options, mutation)
  }
}



// WEBPACK FOOTER //
// ./src/services/user.js